/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pay': {
    width: 20,
    height: 17,
    viewBox: '0 0 20 17',
    data: '<g stroke-width=".9" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M18.366 8.07V4.19" _stroke="#000"/><path pid="1" d="M1.141 2.805v12.083a1.28 1.28 0 0 0 1.288 1.273h15.916v-4.045" _stroke="#234357"/><path pid="2" d="M18.337 4.188l-15.908.003c-.711 0-1.288-.711-1.288-1.588 0-.876.577-1.587 1.288-1.587h14.689M12.671 12.116c-1.117 0-2.021-.893-2.021-1.996s.904-1.996 2.021-1.996h6.305v3.992h-6.305z" _stroke="#234357"/><path pid="3" d="M18.345 2.603H4.15" _stroke="#008AFF"/></g>'
  }
})
